export const customColumnTypes = {
  percent: { cellClass: ['percent', 'monospace', 'text-align-right'] },
};
